// extracted by mini-css-extract-plugin
export var quillEditor = "_ny-1";
export var variable = "_ny-0";